module.exports = __webpack_public_path__ + "static/media/statuslogo.9c231d0f.png";